import { useEffect, useState } from "react";
import { useLookupDemandesQuery } from "../../stores/OkOkStore";
import { BarChart,Bar, YAxis, Tooltip } from "recharts";

import { useTrads } from "../../contexts/trads/useTrads";
import "./DemandeChart.scss";

interface StatusVal {
    en_cours?:number,
    accepte?: number,
    paye?: number,
    refuse?:number,
    attente?:number,
}


function DemandesBarChart({year}:{year:number}){
  const  { data, error, isLoading } =useLookupDemandesQuery({r:{year:year}});
  const [chartData,setChartData]=useState<StatusVal[]>([]);
  const {translate}=useTrads();

  useEffect(()=>{
    const stat:Record<string,number>={};
    const fridge:StatusVal[]=[];
    data?.data.forEach((v)=>{
      stat[v.statut]=(stat[v.statut] || 0) + v.montant;
    });
    fridge.push(stat);
    setChartData(fridge);
   
  },[data,setChartData,translate]);
  const colormap:Record<string,string>={
    'en_cours':'#90b0ccff',
    'accepte': '#28e6ffff',
    'paye': '#0026ffff',
    'refuse':'#f30f0fff',
    'attente': '#c48600ff'
  }
  const COLORS =Object.fromEntries( Object.entries(colormap).map(([k,v])=>[k,{trads:translate(k),color:v}]));
  console.log(COLORS);
  return (
   error ? (
           <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p>

            ) : isLoading ? (
                <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p>
            ) : (data && chartData.length ) ? (
              
             
                <div>
                  <BarChart width={400} height={400} data={chartData} >

                    <YAxis width="auto"  />
                    <Tooltip />

                    {Object.entries(chartData[0]).map(([k]) =>
                    <Bar  name={translate(k)} key={k}
                        barSize={400/5}
                        dataKey={k}
                        fill={colormap[k]}
                    >
                    </Bar>
                    )}
                  </BarChart>
                  <div className="legend">
                    <ul>
                      {Object.entries(chartData[0]).map( ([k])=> (
                        <li key={k}>
                          <span className="legend-color" style={{backgroundColor:COLORS[k].color}}></span>
                          <span>{COLORS[k].trads}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                 
                </div>
                
              
             
            ):null
  );
}

export default DemandesBarChart;